// StronaGlowna.jsx (z optymalizacjami)
import { lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/StronaGlowna/HeroSection";
import OMnieSection from "../components/StronaGlowna/OMnieSection";
import CoWyrozniaSection from "../components/StronaGlowna/CoWyrozniaSection";
import OpinieSection from "../components/StronaGlowna/OpinieSection";
import SekcjaKontakt from "../components/SekcjaKontakt";

// Lazy load komponentów z dużą ilością grafik
const GaleriaSection = lazy(() => import("../components/StronaGlowna/GaleriaSection"));

export default function StronaGlowna() {
  return (
    <motion.div
      className="relative min-h-[100svh] scroll-smooth"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.4 }}
    >
      <Helmet>
        <title>DJ Kusy – DJ na wesele, studniówkę i eventy | Rzeszów, Podkarpacie</title>
        <meta
          name="description"
          content="DJ Kusy – profesjonalna oprawa muzyczna wesel, studniówek i eventów firmowych. Ciężki dym, dekoracja światłem, scena i show. Sprawdź ofertę!"
        />
        <link rel="canonical" href="https://djkusy.pl/" />
        <meta property="og:title" content="DJ Kusy – DJ na wesele i eventy" />
        <meta
          property="og:description"
          content="Sprawdź ofertę DJ-a z Rzeszowa. Wesela, studniówki, imprezy firmowe. Profesjonalna oprawa i prowadzenie imprez."
        />
        <meta property="og:image" content="https://djkusy.pl/og-image.webp" />
        <meta property="og:url" content="https://djkusy.pl/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Preload logo */}
        <link rel="preload" as="image" href="/assets/logo/kusy-logo.webp" fetchpriority="high" />

        {/* Breadcrumbs structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Strona główna",
                "item": "https://djkusy.pl/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "O mnie",
                "item": "https://djkusy.pl/#o-mnie"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Galeria",
                "item": "https://djkusy.pl/#galeria"
              },
              {
                "@type": "ListItem",
                "position": 4,
                "name": "Opinie",
                "item": "https://djkusy.pl/#opinie"
              },
              {
                "@type": "ListItem",
                "position": 5,
                "name": "Kontakt",
                "item": "https://djkusy.pl/#kontakt"
              }
            ]
          })}
        </script>

        {/* WebSite structured data with sections */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "DJ Kusy",
            "url": "https://djkusy.pl",
            "description": "DJ na wesele, studniówkę, event firmowy. Muzyka, światła, ciężki dym i profesjonalne prowadzenie imprez na Podkarpaciu.",
            "inLanguage": "pl-PL",
            "author": {
              "@type": "Person",
              "name": "Filip Kusy"
            },
            "hasPart": [
              {
                "@type": "WebPageElement",
                "name": "O mnie",
                "url": "https://djkusy.pl/#o-mnie"
              },
              {
                "@type": "WebPageElement",
                "name": "Galeria",
                "url": "https://djkusy.pl/#galeria"
              },
              {
                "@type": "WebPageElement",
                "name": "Opinie",
                "url": "https://djkusy.pl/#opinie"
              },
              {
                "@type": "WebPageElement",
                "name": "Kontakt",
                "url": "https://djkusy.pl/#kontakt"
              }
            ]
          })}
        </script>
      </Helmet>

      <HeroSection />

      <div className="py-20 md:py-32 bg-white">
        <OMnieSection />
      </div>

      {/* Fala nad Co mnie wyróżnia? – oryginalna fala2.svg */}
      <img
        loading="lazy"
        width="1920"
        height="80"
        src="/fale/fala2.svg"
        alt=""
        className="w-full -mt-1 select-none pointer-events-none"
      />

      <div className="py-20 md:py-32 bg-zinc-100">
        <CoWyrozniaSection />
      </div>

      {/* Fala pod Co mnie wyróżnia? – oryginalna fala-szara.svg */}
      <img
        loading="lazy"
        width="1920"
        height="80"
        src="/fale/fala-szara.svg"
        alt=""
        className="w-full -mt-1 select-none pointer-events-none"
      />

      <div className="py-20 md:py-32 bg-black text-white">
        <Suspense fallback={
          <div className="w-full min-h-[600px] flex items-center justify-center bg-black text-white text-center text-lg md:text-2xl">
            Ładowanie galerii...
          </div>
        }>
          <GaleriaSection />
        </Suspense>
      </div>

      {/* Fala pod Opinie klientów – oryginalna fala3.svg */}
      <img
        loading="lazy"
        width="1920"
        height="80"
        src="/fale/fala3.svg"
        alt=""
        className="w-full -mt-1 select-none pointer-events-none"
      />

      <div className="py-20 md:py-32 bg-white">
        <OpinieSection />
      </div>

      <div className="bg-white">
        <SekcjaKontakt />
      </div>
    </motion.div>
  );
}
